import React from "react";
import { AvailableSSO } from "../../types/types";
import { StyledSSOButton } from "./styled";

interface Props {
  id: AvailableSSO;
}
const SSOButton: React.FC<Props> = ({ id }) => {
  const renderSSOButton = () => {
    switch (id) {
      case "google":
        return (
          <StyledSSOButton
            backgroundColor="#4285f4"
            hoverBackgroundColor="#357ae8"
            activeBackgroundColor="#29487d"
            color="#ffffff"
            onClick={() => {
              window.location.href =
                process.env.REACT_APP_SERVER_DOMAIN + "/api/v1/google";
            }}
          >
            <img src="/assets/icons/google.png" alt="google_sso_icon" />
            <p>Continue with Google</p>
          </StyledSSOButton>
        );
      case "github":
        return (
          <StyledSSOButton
            backgroundColor="#111111"
            hoverBackgroundColor="#333333"
            activeBackgroundColor="#000000"
            color="#ffffff"
            onClick={() => {
              window.location.href =
                process.env.REACT_APP_SERVER_DOMAIN + "/api/v1/github";
            }}
          >
            <img src="/assets/icons/github.png" alt="github_sso_icon" />
            <p>Continue with GitHub</p>
          </StyledSSOButton>
        );
      default:
        return null;
    }
  };
  return renderSSOButton();
};

export default SSOButton;
